// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__mFi7g","text":"SelectPayment_text__2SZgH","title":"SelectPayment_title__2gfj4","btn":"SelectPayment_btn__1Ls2r"};